/**
 * 供销商-分销商
 */

import ddianImg from '@/assets/images/ddian.png';
import ksouImg from '@/assets/images/ksou.png'
import taobao3Img from '@/assets/images/taobao3.png'
import pduoduoImg from '@/assets/images/pduoduo.png'

const supplier_dictionary = {
  // 分销等级
  DISTRIBUTOR_LEVEL: [
    // { label: '全部', value: 0 },
    { label: '一级', value: 1 },
    { label: '二级', value: 2 },
    { label: '三级', value: 3 },
    { label: '四级', value: 4 },
    { label: '五级', value: 5 },
  ],
  // 合作状态
  REQUEST_STATE: [
    // { label: '待审核', value: 1 },
    { label: '合作中', value: 2 }, // ERP -> 已生效
    { label: '已停止', value: 3 }, // ERP -> 已作废
    { label: '已拒绝', value: 4 },
    { label: '待审核', value: 11 },
    { label: '待授权', value: 12 },
  ],
  // 合作状态回显
  REQUEST_STATE_MAP: {
    1: {
      value: '待审核',
      type: "warning"
    },
    2: {
      value: '合作中', // ERP -> 已生效
      type: "success"
    },
    3: {
      value: '已停止', // ERP -> 已作废
      type: "info"
    },
    4: {
      value: '已拒绝',
      type: "info"
    },
    11: {
      value: '待审核',
      type: "danger"
    },
    12: {
      value: '待授权',
      type: "warning"
    },
  },
  // 入驻状态
  ENTRY_STATE: [
    { label: '未入驻', value: 0 },
    { label: '已入驻', value: 1 },
  ],
  // 入驻状态回显
  ENTRY_STATE_MAP: {
    0: {
      value: '未入驻',
      type: 'info'
    },
    1: {
      value: '已入驻',
      type: 'success'
    },
    2: {
      value: '已入驻',
      type: 'success'
    },
  },
  // 平台上架图标隐射
  /**
    sys:用户自己创建的account
    jd:京东
    tb:淘宝
    tm:天猫
    tjb:淘宝特价版
    1688:阿里巴巴CommonConstants
    wm:微盟
    mls:美丽说
    fx:淘宝分销
    sn:苏宁
    mgj:蘑菇街
    yz:有赞
    ccj:楚楚街
    z800:折800
    wd:微店
    1hd:1号店
    dd:当当
    vip:唯品会
    vipjit:唯品会JIT
    jmyp:聚美优品
    gm:国美
    ymx:亚马逊
    smt:速卖通
    bbtmh:贝贝特卖会
    ecshop:ECShop
    pp:拍拍
    hpz:惠品折
    qmw:千米网
    jp:卷皮
    hzw:孩子王
    pdd:拼多多
    amazon:亚马逊
    kuaj:跨境
    rrd:人人店
    dvd:大V店
    hyk:好衣库
    xhs:小红书
    gs:环球捕手
    ysk:云森客微商城
    wswy:万试无忧
    mt:萌推
    yuncang:云仓
    duodianwulian:多典物联
    yhyx:云货优选
    shangluhua:商陆花
    netease:网易严选
    ymt:洋码头
    tmcs:天猫超市
    haoshiqi:好食期
    wwxx:万物心选
    poison:得物
    tmgjzy:天猫国际直营
    no_shop:无店铺
    akc:爱库存
    dlj:达令家
    fenqile:分期乐
    xmyp:小米有品
    dangkou:档口店铺
    mokuai:魔筷
    pdd_wd:拼多多外单
    twcn:淘外菜鸟
    qibo:启博微分销
    cljn:磁力金牛
    jrbt:今日爆团
    omall:洋葱商城
    kml:卡美啦
    hipac:海拍客
    jd_gxpt:京东供销平台
    fxg:放心购(今日头条)抖音
    kuaishou:快手
   */
  ON_THE_PLATFORM: {
    kuaishou: ksouImg,
    fxg: ddianImg
  },
  PLATFORM_UNSEE_TEXT: '商家设置为不可见',
}


export default supplier_dictionary